import React, { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import ChangeBgIcon from '@wix/da-ds/pkg/Icons/24x24/ChangeBg';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarEditButton from '../../_partials/items/ActionBarEditButton';
import { BiData } from '@wix/da-bi/pkg/events';
const EditBackgroundButton = ({ deviation , currentBackgroundId , onInitialize , showBackgroundPicker , isBackgroundsPopupOpen  })=>{
    var _deviation_background;
    const { t  } = useTranslation();
    useEffect(()=>{
        onInitialize();
    }, [
        onInitialize
    ]);
    const onClick = useCallback(()=>{
        if (isBackgroundsPopupOpen) {
            return;
        }
        showBackgroundPicker(deviation);
    }, [
        deviation,
        isBackgroundsPopupOpen,
        showBackgroundPicker
    ]);
    return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        tooltip: t('deviation.backgrounds.change')
    }, /*#__PURE__*/ React.createElement(ActionBarEditButton, {
        onClick: onClick,
        biData: BiData({
            evid: 370,
            itemid: deviation.deviationId,
            typeid: getDeviationResourceType(deviation),
            background_id: currentBackgroundId,
            core_only: ((_deviation_background = deviation.background) === null || _deviation_background === void 0 ? void 0 : _deviation_background.isPremium) ? 1 : 0
        })
    }, /*#__PURE__*/ React.createElement(ActionBarIcon, {
        icon: ChangeBgIcon
    })));
};
EditBackgroundButton.displayName = 'EditBackgroundButton';
export default EditBackgroundButton;
